module.exports = __webpack_public_path__ + "static/media/meter.8c700992.png";